/* ═══════════════════════════════════════════════════════════════
   customWidgetIcons — name → Lucide component map for the ONE curated
   list the builder's icon picker offers (`CUSTOM_WIDGET_ICONS`,
   shared/entities.ts). No dynamic-import/name-lookup pattern existed
   anywhere else in the app (grepped) — this is a small, additive map
   over the curated list only, never an open-ended icon browser.
   ═══════════════════════════════════════════════════════════════ */
import {
  LayoutGrid,
  ListChecks,
  Users,
  FileText,
  DollarSign,
  Clock,
  Calendar,
  TrendingUp,
  BarChart3,
  PieChart,
  Target,
  Flag,
  AlertTriangle,
  CheckCircle2,
  Receipt,
  Package,
  type LucideIcon,
} from 'lucide-react';
import { CUSTOM_WIDGET_ICONS, type CustomWidgetIcon } from '../../shared/entities';

const CUSTOM_WIDGET_ICON_COMPONENTS: Record<CustomWidgetIcon, LucideIcon> = {
  LayoutGrid,
  ListChecks,
  Users,
  FileText,
  DollarSign,
  Clock,
  Calendar,
  TrendingUp,
  BarChart3,
  PieChart,
  Target,
  Flag,
  AlertTriangle,
  CheckCircle2,
  Receipt,
  Package,
};

/** Name → component, falling back to the curated list's first entry for an
 *  unrecognized/legacy string (never throws on a stale saved widget). */
export function iconFor(name: CustomWidgetIcon | string | undefined): LucideIcon {
  if (name && name in CUSTOM_WIDGET_ICON_COMPONENTS) {
    return CUSTOM_WIDGET_ICON_COMPONENTS[name as CustomWidgetIcon];
  }
  return CUSTOM_WIDGET_ICON_COMPONENTS[CUSTOM_WIDGET_ICONS[0]];
}

export const CUSTOM_WIDGET_ICON_OPTIONS = CUSTOM_WIDGET_ICONS.map((name) => ({
  value: name,
  label: name.replace(/([a-z])([A-Z])/g, '$1 $2'),
  icon: iconFor(name),
}));
